












































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import MantenedorGridSinCodigo from '@/reusable/Grid/MantenedorGridSinCodigo.vue';
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ColumnApi,
  RowNode,
  ICellRendererParams,
} from 'ag-grid-community';
import { LoadingService } from '@/services/loadingService';
import Confirmation from '@/components/Confirmation.vue';
import { fetchEstructuraComercial } from './fetchEstructuraComercial';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    FormFieldsContainer,
    MantenedorGridSinCodigo,
  },
})
export default class EstructuraComercialModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: '' }) type: string;
  @Prop({ default: '' }) title: string;
  @Prop({ default: {} }) leadership: any;
  @Prop({ default: {} }) funcionalidad: any;
  pasoActivoIndex = 1;
  pasos = {
    informacionGeneral: {
      accion: 'Crear - Información General',
      visible: true,
      step: 1,
    },
  };

  showInfo: boolean = true;
  isFormValid: boolean = true;
  formFields: {
    nombre: { label: string; value: string };
    ejecutivos: { label: string; value: any[] };
  } = {
    nombre: { label: 'Nombre', value: '' },
    ejecutivos: { label: 'Ejecutivos', value: [] },
  };
  lastLeader: any;
  leaderItem: any;
  leaders: any[] = [];
  executiveSearch: string = '';
  readonly $snotify: any;
  readonly loadingService = new LoadingService();
  localeText: any = {};
  gridApi: GridApi;
  columnApi: ColumnApi;
  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'id',
        field: 'id',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
        hide: true,
      },
      {
        headerName: '',
        width: 40,
        cellRenderer: this.createAssociateWarning,
        enablePivot: false,
        resizable: false,
        minWidth: 40,
        sortable: false,
        lockVisible: true,
        lockPinned: true,
        cellStyle: { textAlign: 'left' },
      },
      {
        headerName: 'Ejecutivo',
        field: 'nombre',
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 215,
      },
    ],
    rowSelection: 'multiple',
    pagination: true,
    paginationPageSize: 50, //Solución Paginación
    cacheBlockSize: 10000, //Solución Paginación //Ordenamiento + Seleccion
    paginationAutoPageSize: false,
    onGridSizeChanged: event => {
      event.api.sizeColumnsToFit();
    },
    getRowNodeId: (data: any) => data.id,
    isRowSelectable: (params: any) =>
      params.data.isassociate == 'f' && params.data.isleader == 'f',
    suppressRowClickSelection: true,
    suppressCellSelection: false,
    localeText: this.localeText,
    onGridReady: this.onGridReady,
    suppressCopyRowsToClipboard: true,
    onFirstDataRendered: this.handleFirstDataRenderer,
    //onSelectionChanged: this.onSelectionChanged,
    //onRowSelected: this.onSelectionRow,
    //onCellClicked: this.onSelectionRow,
    // onCellMouseOver: this.mouseOverEvent,
    // onCellMouseOut: this.mouseOverOut,
    isExternalFilterPresent: () => {
      return true;
    },
    doesExternalFilterPass: () => {
      return true;
    },
    overlayNoRowsTemplate: 'No hay filas para mostrar',
    blockLoadDebounceMillis: 350,
    //onDragStopped: this.onDragStoppedEvent,
    //onColumnPinned: this.onColumnPinnedEvent,
    columnTypes: {},
    suppressCsvExport: false,
    suppressExcelExport: true,
  };

  /* misc */

  @Watch('show', { immediate: true })
  async onShowChange() {
    if (this.show) {
      this.clearFields();
      if (this.type == 'edit') {
        console.log(this.leadership);
        this.formFields.nombre.value = this.leadership.nombre;
        this.leaderItem = this.leadership.liderid;
        this.lastLeader = this.leadership.liderid;
      }
      this.getExecutives();
    }
  }

  async onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.setRowData([]);
    //this.gridApi.setDomLayout('autoHeight');
  }

  handleFirstDataRenderer() {
    this.gridApi.forEachNode((node: RowNode) => {
      let rowData = node.data;
      if (rowData.iscurrentassociate == 't') {
        this.gridApi.selectNode(node, true, null);
      }
    });
  }

  handleExecutiveSearch() {
    this.gridApi.setQuickFilter(this.executiveSearch);
  }

  handleChangeAutocomplete(value: any) {
    // Desactivar el ejecutivo que está siendo seleccionado como lider
    if (value != '' && value != undefined && value != null) {
      this.gridApi.forEachNode((node: RowNode) => {
        if (node.data.id == value) {
          this.gridApi.deselectNode(node);
          node.setRowSelectable(false);
          node.data.isleader = 't';
          return;
        }
      });
    }
    // Activar el ejecutivo que estaba siendo seleccionado como lider
    if (
      this.lastLeader != '' &&
      this.lastLeader != undefined &&
      this.lastLeader != null
    ) {
      this.gridApi.forEachNode((node: RowNode) => {
        if (node.data.id == this.lastLeader) {
          node.setRowSelectable(true);
          node.data.isleader = 'f';
          //node.setRowSelectable(true);
          return;
        }
      });
    }
    this.gridApi.refreshCells({ force: true });

    this.lastLeader = value;
  }

  clearFields() {
    this.formFields = {
      nombre: { label: 'Nombre', value: '' },
      ejecutivos: { label: 'Giro', value: [] },
    };
    this.lastLeader = '';
    this.leaderItem = '';
    this.executiveSearch = '';
  }

  async handleSaveClient() {
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      let ejecutivos: any[] = this.gridApi.getSelectedNodes();
      if (ejecutivos.length === 0) {
        this.$snotify.error('Debe seleccionar al menos 1 ejecutivo', {
          timeout: 3000,
        });
        return;
      }
      if (this.type == 'create') {
        // Crear Jefatura
        ejecutivos = ejecutivos.map((row: any) => row.data);
        const body = {
          nombre: this.formFields.nombre.value,
          ejecutivos: ejecutivos,
          lider: this.leaderItem,
          id_user: this.getUserID().toString(),
        };
        this.postLeaderShip(body);
      } else {
        // Editar Jefatura
        ejecutivos = ejecutivos.map((row: any) => row.data);
        const body = {
          nombre: this.formFields.nombre.value,
          ejecutivos: ejecutivos,
          lider: this.leaderItem,
          id_user: this.getUserID().toString(),
          jefaturaid: this.leadership.id,
        };
        this.putLeaderShip(body);
      }
    }
  }

  handleCerrar() {
    this.$emit('cerrar');
  }

  async postLeaderShip(body: any) {
    this.loadingService.showLoading();
    fetchEstructuraComercial(body, 'postLeaderShip')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success('Se ha creado la Jefatura', {
            timeout: 3000,
          });
          this.handleCerrar();
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  async putLeaderShip(body: any) {
    this.loadingService.showLoading();
    fetchEstructuraComercial(body, 'putLeaderShip')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success('Se ha actualizado la Jefatura', {
            timeout: 3000,
          });
          this.handleCerrar();
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {})
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  createAssociateWarning(params: any) {
    if (params.data.isleader == 't') {
      let eButton = document.createElement('i');
      eButton.setAttribute(
        'title',
        'El ejecutivo está seleccionado como lÍder'
      );
      eButton.innerHTML =
        '<i aria-hidden="true" class="v-icon material-icons v-alert__icon" style="color: #27488e">person</i>';
      return eButton;
    } else {
      if (params.data.isassociate == 't') {
        let eButton = document.createElement('i');
        eButton.setAttribute(
          'title',
          'El ejecutivo ya está asociado a otra jefatura'
        );
        eButton.innerHTML =
          '<i aria-hidden="true" class="v-icon material-icons v-alert__icon" style="color: #27488e">warning</i>';
        return eButton;
      }
    }
  }

  async getExecutives() {
    this.loadingService.showLoading();
    const body = {
      executives: this.leadership.hasOwnProperty('ids_ejecutivos')
        ? this.leadership.ids_ejecutivos
        : '',
      leadership: this.leadership.hasOwnProperty('id')
        ? this.leadership.id
        : '',
    };
    fetchEstructuraComercial(body, 'getExecutives')
      .then((response: any) => {
        if (response.data.CODIGO_RESPUESTA == '1') {
          this.gridApi.setRowData(response.data.dataGrid);
          this.leaders = response.data.dataDropdown;
        } else {
          this.$snotify.error(response.data.MENSAJE_RESPUESTA, {
            timeout: 3000,
          });
        }
      })
      .catch((error: any) => {
        console.log(error);
        this.$snotify.error('Error al obtener las jefaturas', {
          timeout: 3000,
        });
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  getUserID(): any {
    let user = localStorage.getItem('user');
    let id = JSON.parse(user.replace(/'/g, '"')).id;
    return id;
  }
}
